import { useLocation } from 'react-router';
import { ConcursoProps, ConcursoProvider } from '../../providers/ConcursoProvider';
import Inscripcion from '../Concursos/Gestion/ConcursoPublicado/ComiteTablePublica/Inscripcion';

export const DetallePublico = () => {
  const { state } = useLocation<ConcursoProps>();

  return (
    <>
      <title>Concurso {state.titulo} - ver más</title>
      <ConcursoProvider concurso={state}>
        <Inscripcion />
      </ConcursoProvider>
    </>
  );
};
